<template>
  <div class="relative flex min-h-screen w-full flex-col">
    <Navbar />

    <main>
      <HeroSection />
      <ClientLogoBar id="clients" />
      <TrustMarquee />
      <WhySection id="about" />
      <AiShowcaseSection id="ai" />
      <ProjectsSection id="work" />
      <StatsSection />
      <ProcessSection />
      <ServicesSection id="services" />
      <AiScanSection id="ai-scan" />
      <TestimonialSection />
      <TeamSection />
      <CtaSection />
    </main>

    <FooterSection />
  </div>
</template>

<script setup lang="ts">
import Navbar from '../components/layout/Navbar.vue';
import FooterSection from '../components/layout/FooterSection.vue';

import HeroSection from '../components/sections/HeroSection.vue';
import ClientLogoBar from '../components/sections/ClientLogoBar.vue';
import TrustMarquee from '../components/sections/TrustMarquee.vue';
import WhySection from '../components/sections/WhySection.vue';
import AiShowcaseSection from '../components/sections/AiShowcaseSection.vue';
import ProjectsSection from '../components/sections/ProjectsSection.vue';
import StatsSection from '../components/sections/StatsSection.vue';
import ProcessSection from '../components/sections/ProcessSection.vue';
import AiScanSection from '../components/sections/AiScanSection.vue';
import ServicesSection from '../components/sections/ServicesSection.vue';
import TestimonialSection from '../components/sections/TestimonialSection.vue';
import TeamSection from '../components/sections/TeamSection.vue';
import CtaSection from '../components/sections/CtaSection.vue';
</script>
